<template lang="pug">
.search-result
  .search-result__img(v-if="result.image")
    img(:src="result.image")
  .search-result__content
    h6.search-result__title
      a(:target="openInNewWindow ? '_blank' : false", :href="result.url") {{ result.title }}
    small.search-result__date(v-if="result.itemDate") {{ date }}
    p.search-result__summary {{ result.summary }}
</template>

<script>
export default {
  name: "BlueResultsItem",
  props: ["result", "formatDate", "openInNewWindow"],
  computed: {
    date() {
      return this.formatDate(this.result.itemDate, "MMM dd, yyyy");
    },
  },
};
</script>

<style lang="scss" scoped>
.search-result {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 0;
  padding: 0;
  &:not(:last-child) {
    border-bottom: 1px solid var(--border-color);
    padding-bottom: 1.5rem;
  }
  @include mq(md) {
    flex-direction: row;
    gap: 1.25rem;
  }

  &__img {
    margin: 0 0 1rem;
    @include mq(md) {
      margin: 0;
      flex: 0 0 25%;
    }
    img {
      max-width: 100%;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
  }

  &__title {
    font-size: 1.125rem;
    line-height: 1.25;
    padding: 0;
    margin: 0 0 0.25rem;
  }

  &__date {
    margin: 0;
    padding: 0;
    white-space: nowrap;
    font-size: 0.75rem;
    text-transform: uppercase;
    line-height: 1;
    font-weight: 700;
    opacity: 0.5;
  }

  &__summary {
    font-size: 0.875rem;
    line-height: 1.35rem;
    margin: 0.5rem 0 0;
  }
}
</style>